import { v4 as uuidv4 } from 'uuid'
import {
  ANSWER_ACCEPTANCE,
  Question,
  Questionnaire,
} from '@trustero/trustero-api-web/lib/questionnaire/questionnaire_pb'
import { ParseColumnType } from 'src/Utils/csv/csv.constants'
import { CsvTemplateType } from 'src/Utils/csv/csv.constants'
import { getDownloadCSVFunc } from 'src/components/ModalForms/Reusable/UploadCSVModal.helpers'
import { getCSVBlob } from 'src/Utils/csv/csv.helpers'
import { blobToUint8Array } from 'src/Utils/download.helpers'
import { SecurityQuestionnaireQuestionField } from './securityQuestionnaireModals.constants'

const getAcceptance = (acceptance: ANSWER_ACCEPTANCE): string => {
  switch (acceptance) {
    case ANSWER_ACCEPTANCE.ACCEPTED:
      return 'Accepted'
    case ANSWER_ACCEPTANCE.REJECTED:
      return 'Rejected'
    default:
      return 'Pending'
  }
}

export const downloadSecurityQuestionnaire = (data?: Questionnaire): void => {
  const questions =
    data?.getQuestionsList().map((ele) => ({
      Question: ele.getQuestion() || '',
      Answer: ele.getAnswer() || '',
      Rationale: ele.getAnswerRationale() || '',
      Acceptance: getAcceptance(ele.getAcceptance()),
    })) || ([] as CsvTemplateType[])

  const downloadFunc = getDownloadCSVFunc(
    questions,
    data?.getName() || 'SecurityQuestionnaire',
  )
  downloadFunc()
}

export const getSecurityQuestionnaireParsers = (): ParseColumnType => ({
  question: {
    validator: (_c, _v, _r) => null,
    mutator: (value) => value,
  },
})

export const getEmptyQuestionField =
  (): SecurityQuestionnaireQuestionField => ({
    id: uuidv4(),
    item: {
      question: '',
    },
    isValid: true,
  })

export const getQuestionnaireAsFile = async (
  questions: Question[],
): Promise<Uint8Array> => {
  const data = questions.map((question) => ({
    Question: question.getQuestion() || '',
    Answer: question.getAnswer() || '',
    Rationale: question.getAnswerRationale() || '',
  }))

  const blob = getCSVBlob(data)
  return await blobToUint8Array(blob)
}
